module.exports = __webpack_public_path__ + "static/media/vu.e47a3472.svg";